<div
    class="tribe-common tribe-events tribe-events-view tribe-events-view--list tribe-events--has-filter-bar tribe-events--filter-bar-horizontal tribe-common--breakpoint-xsmall tribe-common--breakpoint-medium tribe-common--breakpoint-full">
    <div class="tribe-common-l-container tribe-events-l-container">
        <h1 class="heading_title__1bzno">Events</h1>

        <header class="tribe-events-header tribe-events-header--has-event-search">
            <div class="event-top-search-bar ">
                <div class=" event-top-search-bar-left">
                    <div class="tribe-events-header__events-bar tribe-events-c-events-bar tribe-events-c-events-bar--border"
                        data-js="tribe-events-events-bar">

                        <div class="tribe-events-c-events-bar__search-container" id="tribe-events-search-container"
                            data-js="tribe-events-search-container">
                            <div class="tribe-events-c-events-bar__search" id="tribe-events-events-bar-search"
                                data-js="tribe-events-events-bar-search">

                                <form (ngSubmit)="onSubmit()" [formGroup]="eventSearchForm"
                                    class="tribe-events-c-search tribe-events-c-events-bar__search-form">

                                    <div class="tribe-events-c-search__input-group">
                                        <div class="tribe-common-form-control-text tribe-events-c-search__input-control tribe-events-c-search__input-control--keyword"
                                            data-js="tribe-events-events-bar-input-control">
                                            <input formControlName="keyword"
                                                class="tribe-common-form-control-text__input tribe-events-c-search__input"
                                                type="text" id="tribe-events-events-bar-keyword"
                                                placeholder="Search for Events">
                                            <svg class="tribe-common-c-svgicon tribe-common-c-svgicon--search tribe-events-c-search__input-control-icon-svg"
                                                viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M11.164 10.133L16 14.97 14.969 16l-4.836-4.836a6.225 6.225 0 01-3.875 1.352 6.24 6.24 0 01-4.427-1.832A6.272 6.272 0 010 6.258 6.24 6.24 0 011.831 1.83 6.272 6.272 0 016.258 0c1.67 0 3.235.658 4.426 1.831a6.272 6.272 0 011.832 4.427c0 1.422-.48 2.773-1.352 3.875zM6.258 1.458c-1.28 0-2.49.498-3.396 1.404-1.866 1.867-1.866 4.925 0 6.791a4.774 4.774 0 003.396 1.405c1.28 0 2.489-.498 3.395-1.405 1.867-1.866 1.867-4.924 0-6.79a4.774 4.774 0 00-3.395-1.405z">
                                                </path>
                                            </svg>
                                        </div>
                                        <div class="tribe-common-form-control-text tribe-events-c-search__input-control tribe-events-c-search__input-control--location"
                                            data-js="tribe-events-events-bar-input-control">
                                            <input formControlName="location"
                                                class="tribe-common-form-control-text__input tribe-events-c-search__input tribe-events-c-search__input--icon"
                                                type="text" id="tribe-events-events-bar-location"
                                                placeholder="Place/Location" autocomplete="off"
                                                (keydown)="locationModified = true" (blur)="onLocationBlur()">
                                            <svg class="tribe-common-c-svgicon tribe-common-c-svgicon--location tribe-events-c-search__input-control-icon-svg"
                                                viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M8.682 1.548a5.166 5.166 0 00-7.375 0C-3.073 5.984 4.959 15.36 4.994 15.36c.051-.001 8.092-9.35 3.688-13.812zM4.994 2.833c1.27 0 2.301 1.043 2.301 2.331 0 1.287-1.03 2.33-2.301 2.33-1.272 0-2.3-1.043-2.3-2.33 0-1.287 1.028-2.331 2.3-2.331z">
                                                </path>
                                            </svg>

                                            <input formControlName="lat" type="hidden" />
                                            <input formControlName="lng" type="hidden" />
                                        </div>
                                    </div>

                                    <button class="tribe-common-c-btn tribe-events-c-search__button" type="submit">
                                        Find Events</button>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
                <div class=" event-top-search-bar-right">
                    <a (click)="onClickNewEvent()"
                        class="listgo-btn listgo-btn btn-primary listgo-btn--md listgo-btn--round">+ Submit Event</a>
                </div>
            </div>

            <div class="tribe-filter-bar tribe-filter-bar--horizontal tribe-filter-bar--open">

                <div class="tribe-filter-bar__form">
                    <!-- <div class="tribe-filter-bar__actions">
                        <button
                            class="tribe-filter-bar-c-clear-button tribe-common-c-btn-border tribe-common-c-btn-border--alt tribe-filter-bar__action-clear"
                            type="reset">
                            <svg class="tribe-common-c-svgicon tribe-common-c-svgicon--reset tribe-filter-bar-c-clear-button__reset-icon"
                                viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.268 7.5a5.633 5.633 0 11-.886-3.033M11.4 1v3.467H7.934" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            <span class="tribe-filter-bar-c-clear-button__text">Clear</span>
                        </button>
                    </div> -->

                    <div
                        class="tribe-filter-bar__filters-slider-container tribe-swiper-container tribe-swiper-container-initialized tribe-swiper-container-horizontal tribe-swiper-container-free-mode">
                        <div class="tribe-filter-bar__filters-slider-wrapper tribe-swiper-wrapper"
                            style="transition-duration: 0ms;">
                            <div class="tribe-filter-bar__filters-slide tribe-swiper-slide">
                                <div
                                    class="tribe-filter-bar-c-pill tribe-filter-bar-c-pill--button tribe-filter-bar__filters-slide-pill">
                                    <button
                                        class="tribe-filter-bar-c-pill__pill tribe-common-b2 tribe-common-b3--min-medium"
                                        type="button"
                                        (click)="queryParams.is_virtual = queryParams.is_virtual == 0 ? 1 : 0; onSubmit()"
                                        [ngClass]="{'wil-btn--primary': queryParams.is_virtual}">
                                        <span class="tribe-filter-bar-c-pill__pill-label">Virtual Events</span>
                                    </button>
                                </div>
                            </div>
                            <div class="tribe-filter-bar__filters-slide tribe-swiper-slide">
                                <div
                                    class="tribe-filter-bar-c-pill tribe-filter-bar-c-pill--button tribe-filter-bar__filters-slide-pill">
                                    <button
                                        class="tribe-filter-bar-c-pill__pill tribe-common-b2 tribe-common-b3--min-medium"
                                        type="button"
                                        (click)="queryParams.featured = queryParams.featured == 0 ? 1 : 0; onSubmit()"
                                        [ngClass]="{'wil-btn--primary': queryParams.featured}">
                                        <span class="tribe-filter-bar-c-pill__pill-label">Featured Events</span>
                                    </button>
                                </div>
                            </div>
                            <div class="tribe-filter-bar__filters-slide tribe-swiper-slide">
                                <div
                                    class="tribe-filter-bar-c-pill tribe-filter-bar-c-pill--button tribe-filter-bar__filters-slide-pill">
                                    <button (click)="openEventCategoryModal()"
                                        class="tribe-filter-bar-c-pill__pill tribe-common-b2 tribe-common-b3--min-medium"
                                        [ngClass]="{'wil-btn--primary': queryParams.category}" type="button">
                                        <span class="tribe-filter-bar-c-pill__pill-label">{{selectedCategory != null ?
                                            'Event Category: '+selectedCategory :
                                            'Event Category'}}</span>
                                    </button>
                                </div>
                            </div>
                            <div class="tribe-filter-bar__filters-slide tribe-swiper-slide">
                                <div
                                    class="tribe-filter-bar-c-pill tribe-filter-bar-c-pill--button tribe-filter-bar__filters-slide-pill">
                                    <button (click)="openEventOrganizerModal()"
                                        class="tribe-filter-bar-c-pill__pill tribe-common-b2 tribe-common-b3--min-medium"
                                        [ngClass]="{'wil-btn--primary': queryParams.organisers}" type="button">
                                        <span class="tribe-filter-bar-c-pill__pill-label">{{selectedOrganizer != null ?
                                            'Organizers: '+selectedOrganizer :
                                            'Organizers'}}</span>
                                    </button>
                                </div>
                            </div>
                            <!-- <div class="tribe-filter-bar__filters-slide tribe-swiper-slide">
                                <div
                                    class="tribe-filter-bar-c-pill tribe-filter-bar-c-pill--button tribe-filter-bar__filters-slide-pill">
                                    <button (click)="openEventVenueModal()"
                                        class="tribe-filter-bar-c-pill__pill tribe-common-b2 tribe-common-b3--min-medium"
                                        [ngClass]="{'wil-btn--primary': queryParams.venue != null}" type="button">
                                        <span class="tribe-filter-bar-c-pill__pill-label">{{selectedVenue != null ?
                                            'Venue: '+selectedVenue :
                                            'Venue'}}</span>
                                    </button>
                                </div>
                            </div>
                            <div class="tribe-filter-bar__filters-slide tribe-swiper-slide">
                                <div
                                    class="tribe-filter-bar-c-pill tribe-filter-bar-c-pill--button tribe-filter-bar__filters-slide-pill">
                                    <button (click)="openEventCityModal()"
                                        class="tribe-filter-bar-c-pill__pill tribe-common-b2 tribe-common-b3--min-medium"
                                        [ngClass]="{'wil-btn--primary': queryParams.city != null}" type="button">
                                        <span class="tribe-filter-bar-c-pill__pill-label">{{selectedCity != null ?
                                            'City: '+selectedCity :
                                            'City'}}</span>
                                    </button>
                                </div>
                            </div> -->
                            <div class="tribe-filter-bar__filters-slide tribe-swiper-slide">
                                <div
                                    class="tribe-filter-bar-c-pill tribe-filter-bar-c-pill--button tribe-filter-bar__filters-slide-pill">
                                    <button (click)="openEventDateModal()"
                                        class="tribe-filter-bar-c-pill__pill tribe-common-b2 tribe-common-b3--min-medium"
                                        type="button" [ngClass]="{'wil-btn--primary': queryParams.start_time
                                        != '' && queryParams.end_time != ''}">
                                        <span class="tribe-filter-bar-c-pill__pill-label">Date{{(queryParams.start_time
                                            != '' && queryParams.end_time != '') ?
                                            ': '+queryParams.start_time + ' - ' + queryParams.end_time :
                                            ''}}</span>
                                    </button>
                                </div>
                            </div>
                            <!-- <div class="tribe-filter-bar__filters-slide tribe-swiper-slide">
                                <div
                                    class="tribe-filter-bar-c-pill tribe-filter-bar-c-pill--button tribe-filter-bar__filters-slide-pill">
                                    <button
                                        class="tribe-filter-bar-c-pill__pill tribe-common-b2 tribe-common-b3--min-medium"
                                        type="button">
                                        <span class="tribe-filter-bar-c-pill__pill-label">Cost (£)</span>
                                    </button>
                                </div>
                            </div> -->
                        </div>
                    </div>

                </div>
            </div>


            <!-- <div class="tribe-events-c-top-bar tribe-events-header__top-bar">

                <nav class="tribe-events-c-top-bar__nav tribe-common-a11y-hidden">
                    <ul class="tribe-events-c-top-bar__nav-list">
                        <li class="tribe-events-c-top-bar__nav-list-item">
                            <a class="tribe-common-c-btn-icon tribe-common-c-btn-icon--caret-left tribe-events-c-top-bar__nav-link tribe-events-c-top-bar__nav-link--prev"
                                title="Previous Events">
                            </a>
                        </li>

                        <li class="tribe-events-c-top-bar__nav-list-item">
                            <a class="tribe-common-c-btn-icon tribe-common-c-btn-icon--caret-right tribe-events-c-top-bar__nav-link tribe-events-c-top-bar__nav-link--next"
                                title="Next Events">
                            </a>
                        </li>
                    </ul>
                </nav>

                <a class="tribe-common-c-btn-border-small tribe-events-c-top-bar__today-button tribe-common-a11y-hidden"
                    title="Click to select today's date">
                    Today</a>

                <div class="tribe-events-c-top-bar__datepicker">
                    <button class="tribe-common-h3 tribe-common-h--alt tribe-events-c-top-bar__datepicker-button"
                        type="button">
                        <time datetime="2021-05-09" class="tribe-events-c-top-bar__datepicker-time">
                            <span class="tribe-events-c-top-bar__datepicker-mobile">
                                Now </span>
                            <span class="tribe-events-c-top-bar__datepicker-desktop tribe-common-a11y-hidden">
                                Now </span>
                        </time>
                        <span class="tribe-events-c-top-bar__datepicker-separator"> - </span>
                        <time datetime="2021-05-15" class="tribe-events-c-top-bar__datepicker-time">
                            <span class="tribe-events-c-top-bar__datepicker-mobile">
                                5/15/2021 </span>
                            <span class="tribe-events-c-top-bar__datepicker-desktop tribe-common-a11y-hidden">
                                May 15, 2021 </span>
                        </time>
                        <svg class="tribe-common-c-svgicon tribe-common-c-svgicon--caret-down tribe-events-c-top-bar__datepicker-button-icon-svg"
                            viewBox="0 0 10 7" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M1.008.609L5 4.6 8.992.61l.958.958L5 6.517.05 1.566l.958-.958z"
                                class="tribe-common-c-svgicon__svg-fill"></path>
                        </svg>
                    </button>
                </div>
            </div> -->
        </header>

        <div class="tribe-events-calendar-list">
            <!-- <div class="tribe-events-calendar-list__month-separator">
                <time
                    class="tribe-events-calendar-list__month-separator-text tribe-common-h7 tribe-common-h6--min-medium tribe-common-h--alt"
                    datetime="2021-05">
                    May 2021 </time>
            </div> -->

            <div *ngIf="totalItems == 0" class="alert_module__Q4QZx" style="margin: 30px 0;">
                <div class="alert_content__1ntU3">Sorry, We found no posts matched what are you looking for
                    ...</div>
            </div>

            <div *ngIf="totalItems > 0">
                <div *ngFor="let item of events" class="tribe-common-g-row tribe-events-calendar-list__event-row">

                    <!-- <div class="tribe-events-calendar-list__event-date-tag tribe-common-g-col">
                        <time class="tribe-events-calendar-list__event-date-tag-datetime" datetime="2021-05-09">
                            <span class="tribe-events-calendar-list__event-date-tag-weekday">
                                Sun </span>
                            <span
                                class="tribe-events-calendar-list__event-date-tag-daynum tribe-common-h5 tribe-common-h4--min-medium">
                                9 </span>
                        </time>
                    </div> -->

                    <div class="tribe-events-calendar-list__event-wrapper tribe-common-g-col">
                        <article
                            class="tribe-events-calendar-list__event tribe-common-g-row tribe-common-g-row--gutters post-17251 tribe_events type-tribe_events status-publish has-post-thumbnail hentry tag-dance tribe_events_cat-performing-visual-arts cat_performing-visual-arts">
                            <div class="tribe-events-calendar-list__event-featured-image-wrapper tribe-common-g-col">
                                <a href="{{ siteUrl + '/events/details/' + item.slug }}"
                                    class="tribe-events-calendar-list__event-featured-image-link">
                                    <img src="{{ item.featured_img | imageSrc : 'event' : 'medium' }}"
                                        class="tribe-events-calendar-list__event-featured-image">
                                </a>
                            </div>

                            <div class="tribe-events-calendar-list__event-details tribe-common-g-col">

                                <header class="tribe-events-calendar-list__event-header">
                                    <div class="tribe-events-calendar-list__event-datetime-wrapper tribe-common-b2">
                                        <time class="tribe-events-calendar-list__event-datetime" datetime="2021-05-09">
                                            <span class="tribe-event-date-start">{{ item.start_time | date : 'MMMM d,
                                                y @ h:mm a' }}</span> - <span class="tribe-event-time">{{ item.end_time
                                                | date : 'MMMM d,
                                                y @ h:mm a' }}</span> </time>
                                    </div>
                                    <h3
                                        class="tribe-events-calendar-list__event-title tribe-common-h6 tribe-common-h4--min-medium">
                                        <a href="{{ siteUrl + '/events/details/' + item.slug }}"
                                            title="{{ item.title }}"
                                            class="tribe-events-calendar-list__event-title-link tribe-common-anchor-thin">
                                            {{ item.title }} </a>
                                    </h3>
                                    <address *ngIf="item.is_virtual != 1 && item.address != ''"
                                        class="tribe-events-calendar-list__event-venue tribe-common-b2">
                                        <span class="tribe-events-calendar-list__event-venue-address">
                                            {{ item.address }} </span>
                                    </address>
                                    <div *ngIf="item.is_virtual == 1"
                                        class="tribe-common-b2 tribe-common-b2--bold tribe-events-virtual-virtual-event">
                                        <em class="tribe-events-virtual-virtual-event__icon" aria-label="Virtual"
                                            title="Virtual">
                                            <svg class="tribe-events-virtual-icon tribe-events-virtual-icon--virtual tribe-events-virtual-virtual-event__icon-svg"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 16">
                                                <defs></defs>
                                                <g fill="none" fill-rule="evenodd" stroke="#000000"
                                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    transform="translate(1 1)">
                                                    <path
                                                        d="M18 10.7333333c2.16-2.09999997 2.16-5.44444441 0-7.46666663M21.12 13.7666667c3.84-3.7333334 3.84-9.80000003 0-13.53333337M6 10.7333333C3.84 8.63333333 3.84 5.28888889 6 3.26666667M2.88 13.7666667C-.96 10.0333333-.96 3.96666667 2.88.23333333">
                                                    </path>
                                                    <ellipse cx="12" cy="7" rx="2.4" ry="2.33333333"></ellipse>
                                                </g>
                                            </svg>
                                        </em>
                                        <span class="tribe-events-virtual-virtual-event__text">Virtual Event</span>
                                    </div>
                                </header>

                                <div
                                    class="tribe-events-calendar-list__event-description tribe-common-b2 tribe-common-a11y-hidden">
                                    {{ item.description | excerpt }}
                                </div>

                            </div>
                        </article>
                    </div>

                </div>
            </div>

        </div> <!-- tribe-events-calendar-list -->

        <pagination [totalItems]="totalItems" [currentPage]="queryParams.page" [pageSize]="queryParams.limit"
            (pageChange)="onPageChange($event)"></pagination>

    </div>
</div>